import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 21,
	viewBox: "0 0 29 21",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "switch_access_2",
		opacity: .9,
		d: "M0.0742188 20.5938V0.59375H12.6567V4.65982H11.2281V2.02232H1.50279V19.1652H11.2281V16.5277H12.6567V20.5938H0.0742188ZM16.0631 20.5938V16.5277H17.4917V19.1652H20.651V20.5938H16.0631ZM24.0578 20.5938V19.1652H27.2171V16.5277H28.6456V20.5938H24.0578ZM16.0631 4.65982V0.59375H20.651V2.02232H17.4917V4.65982H16.0631ZM27.2171 4.65982V2.02232H24.0578V0.59375H28.6456V4.65982H27.2171ZM21.3106 15.0445L20.2996 14.0334L23.0714 11.308H5.761V9.87946H23.0714L20.2996 7.15411L21.3106 6.14304L25.816 10.5938L21.3106 15.0445Z",
		fill: "currentColor",
		style: {
			fill: "currentColor",
			fillOpacity: .8
		}
	})
});
export default SvgBill;
